import { render, staticRenderFns } from "./FinishTaskDialog.vue?vue&type=template&id=68ccd2d0"
import script from "./FinishTaskDialog.vue?vue&type=script&lang=js"
export * from "./FinishTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./FinishTaskDialog.vue?vue&type=style&index=0&id=68ccd2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports